// components/postComment.js


export const fetchPostWithComments = async (
  postId,
  {
    limit = 100,
    skip = 0,
  } = {}
) => {

  if (!postId) {
    throw new Error("postId is required");
  }

  const res = await fetch(
    `/api/post-comments/${postId}?limit=${limit}&skip=${skip}`,
    {
      credentials: "include",
    }
  );

  if (!res.ok) {

    const err =
      await res.json().catch(() => ({}));

    throw new Error(
      err.message ||
      "Failed to fetch post comments"
    );
  }

  return res.json();
};